import Image from "@p-ban/common/src/components/html/Image"

type Props = {
  src: string
  title: string
  subTitle?: string
  children: React.ReactNode
}

const ServiceResult = ({ src, title, subTitle, children }: Props) => {
  return (
    <div>
      <div className="pb-2">
        <div className="flex items-center pb-2">
          <Image src={src} alt="" width={32} height={30} />
          <div className="pl-1 leading-none">
            <span
              className="text-xs font-[600] tracking-tighter text-[#32383E]"
              style={{ fontFeatureSettings: '"palt"' }}
            >
              {title}
            </span>
            {subTitle && <span className="text-xs font-medium tracking-tighter text-neutral-400">{subTitle}</span>}
          </div>
        </div>
        {children}
      </div>
    </div>
  )
}

export default ServiceResult
